import { render, staticRenderFns } from "./RequestConfirmationDialog.vue?vue&type=template&id=3e56f577"
import script from "./RequestConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./RequestConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports